// Default connx grid table theme
const darkGrid = [
  ['--connx-grid-border-outer-radius', '0.5rem'],
  ['--connx-grid-border-outer', 'var(--connx-grey-tint-65)'],
  ['--connx-grid-border-default', 'var(--connx-grey-tint-65)'],

  ['--connx-grid-row-grouped-background', 'var(--connx-secondary-tint-95)'],
  ['--connx-grid-row-grouped-text', 'var(--connx-grey-shade-15)'],
  ['--connx-grid-row-grouped-icon-background', 'transparent'],
  ['--connx-grid-row-grouped-icon-text', 'var(--connx-headers-shade-65)'],
  ['--connx-grid-row-grouped-icon-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-row-grouped-icon-text-hover', 'var(--connx-headers-shade-35)'],

  ['--connx-grid-header-background', 'var(--connx-headers)'],
  ['--connx-grid-header-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-header-background-hover', 'var(--connx-headers-tint-15)'],
  ['--connx-grid-header-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-header-sort-background', 'transparent'],
  ['--connx-grid-header-sort-text', 'inherit'],
  ['--connx-grid-header-sort-background-hover', 'var(--connx-white)'],
  ['--connx-grid-header-sort-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-header-drag-background', 'var(--connx-primary)'],
  ['--connx-grid-header-drag-text', 'var(--connx-white)'],

  ['--connx-grid-filter-container-background', 'var(--connx-white)'],
  ['--connx-grid-filter-icon-background', 'transparent'],
  ['--connx-grid-filter-icon-color', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-filter-icon-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-filter-icon-color-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-filter-icon-border', 'transparent'],
  ['--connx-grid-filter-icon-border-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-control-icon-background', 'var(--connx-grey-tint-95)'],
  ['--connx-grid-filter-control-icon-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-filter-control-icon-background-hover', 'var(--connx-headers-tint-85)'],
  ['--connx-grid-filter-control-icon-text-hover', 'inherit'],
  ['--connx-grid-filter-background', 'var(--connx-white)'],
  ['--connx-grid-filter-text', 'var(--connx-grey)'],
  ['--connx-grid-filter-background-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-filter-background-selected', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-filter-text-selected', 'var(--connx-grey)'],

  ['--connx-grid-sort-icon', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-sort-icon-hover', 'var(--connx-headers-shade-05)'],

  ['--connx-grid-row-odd-background', 'var(--connx-white)'],
  ['--connx-grid-row-odd-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-row-even-background', 'var(--connx-white)'],
  ['--connx-grid-row-even-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-row-odd-background-hover', 'var(--connx-headers-tint-80)'],
  ['--connx-grid-row-odd-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-row-even-background-hover', 'var(--connx-headers-tint-80)'],
  ['--connx-grid-row-even-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-row-selected-background', 'var(--connx-headers-tint-80)'],
  ['--connx-grid-row-selected-text', 'var(--connx-headers-shade-20)'],
  ['--connx-grid-row-link-text', 'var(--connx-primary)'],
  ['--connx-grid-row-link-text-hover', 'var(--connx-primary)'],

  ['--connx-grid-command-cell-background', 'var(--connx-headers-tint-95)'],
  ['--connx-grid-command-cell-button-text', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-command-cell-button-background', 'transparent'],
  ['--connx-grid-command-cell-button-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-command-cell-button-background-hover', 'var(--connx-headers)'],

  ['--connx-grid-pager-background', 'var(--connx-white)'],
  ['--connx-grid-pager-text', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-pager-button-text', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-pager-button-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-pager-button-background', 'transparent'],
  ['--connx-grid-pager-button-background-hover', 'var(--connx-grey-tint-80)'],
];

const defaultGrid = [
  ['--connx-grid-border-outer-radius', '0.5rem'],
  ['--connx-grid-border-outer', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-border-default', 'var(--connx-headers-shade-05)'],

  ['--connx-grid-group-background', 'var(--connx-white)'],
  ['--connx-grid-group-text', 'var(--connx-grey-shade-15)'],
  ['--connx-grid-group-item-background', 'var(--connx-white)'],
  ['--connx-grid-group-item-text', 'var(--connx-headers-shade-45)'],
  ['--connx-grid-group-item-sort-background', 'transparent'],
  ['--connx-grid-group-item-sort-text', 'var(--connx-headers-shade-45)'],
  ['--connx-grid-group-item-sort-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-group-item-sort-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-group-item-sort-border', 'transparent'],
  ['--connx-grid-group-item-sort-border-hover', 'var(--connx-grey-tint-85)'],

  ['--connx-grid-row-grouped-background', 'var(--connx-headers)'],
  ['--connx-grid-row-grouped-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-row-grouped-icon-background', 'transparent'],
  ['--connx-grid-row-grouped-icon-text', 'var(--connx-headers-shade-65)'],
  ['--connx-grid-row-grouped-icon-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-row-grouped-icon-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-header-background', 'var(--connx-headers)'],
  ['--connx-grid-header-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-header-background-hover', 'var(--connx-headers-tint-35)'],
  ['--connx-grid-header-text-hover', 'var(--connx-headers-shade-65)'],
  ['--connx-grid-header-sort-background', 'transparent'],
  ['--connx-grid-header-sort-text', 'inherit'],
  ['--connx-grid-header-sort-background-hover', 'var(--connx-white)'],
  ['--connx-grid-header-sort-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-header-drag-background', 'var(--connx-primary)'],
  ['--connx-grid-header-drag-text', 'var(--connx-white)'],
  ['--connx-grid-filter-container-background', 'var(--connx-white)'],
  ['--connx-grid-filter-icon-background', 'transparent'],
  ['--connx-grid-filter-icon-color', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-filter-icon-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-filter-icon-color-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-filter-icon-border', 'transparent'],
  ['--connx-grid-filter-icon-border-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-control-icon-background', 'var(--connx-grey-tint-95)'],
  ['--connx-grid-filter-control-icon-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-filter-control-icon-background-hover', 'var(--connx-headers-tint-85)'],
  ['--connx-grid-filter-control-icon-text-hover', 'inherit'],

  ['--connx-grid-filter-background', 'var(--connx-white)'],
  ['--connx-grid-filter-text', 'var(--connx-grey)'],
  ['--connx-grid-filter-background-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-filter-background-selected', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-filter-text-selected', 'var(--connx-grey)'],

  ['--connx-grid-sort-icon', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-sort-icon-hover', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-row-odd-background', 'var(--connx-white)'],
  ['--connx-grid-row-odd-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-row-even-background', 'var(--connx-white)'],
  ['--connx-grid-row-even-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-row-odd-background-hover', 'var(--connx-grey-tint-95)'],
  ['--connx-grid-row-odd-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-row-even-background-hover', 'var(--connx-grey-tint-95)'],
  ['--connx-grid-row-even-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-row-selected-background', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-row-selected-text', 'var(--connx-headers-shade-75)'],
  ['--connx-grid-row-link-text', 'var(--connx-primary)'],
  ['--connx-grid-row-link-text-hover', 'var(--connx-primary)'],
  ['--connx-grid-command-cell-background', 'transparent'],
  ['--connx-grid-command-cell-button-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-command-cell-button-background', 'transparent'],
  ['--connx-grid-command-cell-button-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-command-cell-button-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-pager-background', 'var(--connx-white)'],
  ['--connx-grid-pager-text', 'var(--connx-grey-shade-15)'],
  ['--connx-grid-pager-button-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-pager-button-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-pager-button-background', 'transparent'],
  ['--connx-grid-pager-button-background-hover', 'var(--connx-grey-tint-80)'],
];

const lightGrid = [
  ['--connx-grid-border-outer-radius', '0.5rem'],
  ['--connx-grid-border-outer', 'var(--connx-grey-tint-65)'],
  ['--connx-grid-border-default', 'var(--connx-grey-tint-65)'],

  ['--connx-grid-row-grouped-background', 'var(--connx-secondary-tint-95)'],
  ['--connx-grid-row-grouped-text', 'var(--connx-grey-shade-15)'],
  ['--connx-grid-row-grouped-icon-background', 'transparent'],
  ['--connx-grid-row-grouped-icon-text', 'var(--connx-headers-shade-65)'],
  ['--connx-grid-row-grouped-icon-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-row-grouped-icon-text-hover', 'var(--connx-headers-shade-35)'],

  ['--connx-grid-header-background', 'var(--connx-headers)'],
  ['--connx-grid-header-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-header-background-hover', 'var(--connx-headers-shade-15)'],
  ['--connx-grid-header-text-hover', 'var(--connx-headers-shade-65)'],
  ['--connx-grid-header-sort-background', 'transparent'],
  ['--connx-grid-header-sort-text', 'inherit'],
  ['--connx-grid-header-sort-background-hover', 'var(--connx-white)'],
  ['--connx-grid-header-sort-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-header-drag-background', 'var(--connx-primary)'],
  ['--connx-grid-header-drag-text', 'var(--connx-white)'],

  ['--connx-grid-filter-container-background', 'var(--connx-white)'],
  ['--connx-grid-filter-icon-background', 'transparent'],
  ['--connx-grid-filter-icon-color', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-filter-icon-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-filter-icon-color-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-filter-icon-border', 'transparent'],
  ['--connx-grid-filter-icon-border-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-control-icon-background', 'var(--connx-grey-tint-95)'],
  ['--connx-grid-filter-control-icon-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-filter-control-icon-background-hover', 'var(--connx-headers-tint-85)'],
  ['--connx-grid-filter-control-icon-text-hover', 'inherit'],

  ['--connx-grid-filter-background', 'var(--connx-white)'],
  ['--connx-grid-filter-text', 'var(--connx-grey)'],
  ['--connx-grid-filter-background-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-filter-background-selected', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-filter-text-selected', 'var(--connx-grey)'],

  ['--connx-grid-sort-icon', 'var(--connx-headers-shade-05)'],
  ['--connx-grid-sort-icon-hover', 'var(--connx-headers-shade-05)'],

  ['--connx-grid-row-odd-background', 'var(--connx-white)'],
  ['--connx-grid-row-odd-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-row-even-background', 'var(--connx-white)'],
  ['--connx-grid-row-even-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-row-odd-background-hover', 'var(--connx-headers-tint-25)'],
  ['--connx-grid-row-odd-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-row-even-background-hover', 'var(--connx-headers-tint-25)'],
  ['--connx-grid-row-even-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-row-selected-background', 'var(--connx-headers)'],
  ['--connx-grid-row-selected-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-row-link-text', 'var(--connx-primary)'],
  ['--connx-grid-row-link-text-hover', 'var(--connx-primary)'],

  ['--connx-grid-command-cell-background', 'var(--connx-headers-tint-95)'],
  ['--connx-grid-command-cell-button-text', 'var(--connx-headers-shade-25)'],
  ['--connx-grid-command-cell-button-background', 'transparent'],
  ['--connx-grid-command-cell-button-text-hover', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-command-cell-button-background-hover', 'var(--connx-headers)'],

  ['--connx-grid-pager-background', 'var(--connx-white)'],
  ['--connx-grid-pager-text', 'var(--connx-headers-shade-25)'],
  ['--connx-grid-pager-button-text', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-pager-button-text-hover', 'var(--connx-headers-shade-35)'],
  ['--connx-grid-pager-button-background', 'transparent'],
  ['--connx-grid-pager-button-background-hover', 'var(--connx-grey-tint-80)'],
];

const whiteGrid = [
  ['--connx-grid-border-outer-radius', '0.5rem'],
  ['--connx-grid-border-outer', 'var(--connx-grey-tint-65)'],
  ['--connx-grid-border-default', 'var(--connx-grey-tint-65)'],

  ['--connx-grid-row-grouped-icon-text', 'var(--connx-grey-shade-65)'],
  ['--connx-grid-row-grouped-icon-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-header-sort-text-hover', 'var(--connx-grey-shade-35)'],

  ['--connx-grid-filter-background', 'var(--connx-white)'],
  ['--connx-grid-filter-icon-color-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-filter-control-icon-background-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-text', 'var(--connx-grey)'],
  ['--connx-grid-filter-background-hover', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-filter-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-filter-background-selected', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-filter-text-selected', 'var(--connx-grey)'],

  ['--connx-grid-sort-icon', 'var(--connx-grey-shade-05)'],
  ['--connx-grid-sort-icon-hover', 'var(--connx-grey-shade-05)'],
  ['--connx-grid-row-odd-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-row-even-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-row-selected-text', 'var(--connx-grey-shade-20)'],
  ['--connx-grid-command-cell-button-text-hover', 'var(--connx-grey-shade-05)'],
  ['--connx-grid-pager-button-text', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-pager-button-text-hover', 'var(--connx-grey-shade-35)'],
  ['--connx-grid-row-selected-background', 'var(--connx-grey-tint-65)'],

  ['--connx-grid-group-item-text', 'var(--connx-grey)'],
  ['--connx-grid-header-background', 'var(--connx-white)'],
  ['--connx-grid-header-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-grid-header-text', 'var(--connx-grid-heading-text)'],
  ['--connx-grid-header-text-hover', 'var(--connx-grey)'],
  ['--connx-grid-command-cell-background', 'var(--connx-white)'],
  ['--connx-grid-pager-background', 'var(--connx-white)'],
  ['--connx-grid-row-odd-background', 'var(--connx-white)'],
  ['--connx-grid-row-odd-background-hover', 'var(--connx-grey-tint-75)'],
  ['--connx-grid-row-even-background', 'var(--connx-white)'],
  ['--connx-grid-row-even-background-hover', 'var(--connx-grey-tint-75)'],
  ['--connx-grid-filter-icon-border', 'var(--connx-grey-tint-45)'],
  ['--connx-grid-filter-icon-color', 'var(--connx-grey-tint-45)'],
  ['--connx-grid-pager-text', 'var(--connx-grey-tint-20)'],
  ['--connx-grid-command-cell-button-text', 'var(--connx-grey-tint-20)'],
  ['--connx-grid-command-cell-button-background', 'var(--connx-grey-tint-85)'],
  ['--connx-grid-command-cell-button-background-hover', 'var(--connx-grey-tint-65)'],
];

const darkAccordion = [
  ['--connx-accordion-header-background', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text', 'var(--connx-accordion-heading-text)'],

  ['--connx-accordion-header-background-hover', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text-hover', 'var(--connx-accordion-heading-text)'],

  ['--connx-accordion-header-background-active', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text-active', 'var(--connx-accordion-heading-text)'],

  ['--connx-accordion-header-icon-background', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color', 'var(--connx-accordion-tint-35)'],

  ['--connx-accordion-header-icon-background-hover', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color-hover', 'var(--connx-accordion-tint-35)'],

  ['--connx-accordion-header-icon-background-active', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color-active', 'var(--connx-accordion-tint-35)'],

  ['--connx-accordion-border-radius', '0.5rem'],
  ['--connx-accordion-border', 'var(--connx-grey-tint-65)'],
  ['--connx-accordion-border-bottom', 'var(--connx-accordion-border)'],
  ['--connx-accordion-background', 'var(--connx-white)'],
];

const defaultAccordion = [
  ['--connx-accordion-header-background', 'var(--connx-white)'],
  ['--connx-accordion-header-text', 'var(--connx-grey-shade-15)'],

  ['--connx-accordion-header-background-hover', 'var(--connx-white)'],
  ['--connx-accordion-header-text-hover', 'var(--connx-primary)'],

  ['--connx-accordion-header-background-active', 'var(--connx-white)'],
  ['--connx-accordion-header-text-active', 'var(--connx-primary)'],

  ['--connx-accordion-header-icon-background', 'var(--connx-accordion-shade-05)'],
  ['--connx-accordion-header-icon-color', 'var(--connx-white)'],

  ['--connx-accordion-header-icon-background-hover', 'var(--connx-info-tint-45)'],
  ['--connx-accordion-header-icon-color-hover', 'var(--connx-white)'],

  ['--connx-accordion-header-icon-background-active', 'var(--connx-info-tint-45)'],
  ['--connx-accordion-header-icon-color-active', 'var(--connx-white)'],

  ['--connx-accordion-border-radius', '0.5rem'],
  ['--connx-accordion-border', 'var(--connx-accordion-shade-05)'],
  ['--connx-accordion-border-bottom', 'var(--connx-white)'],
  ['--connx-accordion-background', 'var(--connx-white)'],
];

const lightAccordion = [
  ['--connx-accordion-header-background', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text', 'var(--connx-accordion-heading-text)'],

  ['--connx-accordion-header-background-hover', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text-hover', 'var(--connx-accordion-heading-text)'],

  ['--connx-accordion-header-background-active', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text-active', 'var(--connx-accordion-heading-text)'],

  ['--connx-accordion-header-icon-background', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color', 'var(--connx-accordion-shade-35)'],

  ['--connx-accordion-header-icon-background-hover', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color-hover', 'var(--connx-accordion-shade-35)'],

  ['--connx-accordion-header-icon-background-active', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color-active', 'var(--connx-accordion-shade-35)'],

  ['--connx-accordion-border-radius', '0.5rem'],
  ['--connx-accordion-border', 'var(--connx-grey-tint-65)'],
  ['--connx-accordion-border-bottom', 'var(--connx-accordion-border)'],
  ['--connx-accordion-background', 'var(--connx-white)'],
];

const whiteAccordion = [
  ['--connx-accordion-header-background', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text', 'var(--connx-grey)'],

  ['--connx-accordion-header-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-accordion-header-text-hover', 'var(--connx-grey)'],

  ['--connx-accordion-header-background-active', 'var(--connx-accordion)'],
  ['--connx-accordion-header-text-active', 'var(--connx-grey)'],

  ['--connx-accordion-header-icon-background', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color', 'var(--connx-grey)'],

  ['--connx-accordion-header-icon-background-hover', 'var(--connx-grey-tint-80)'],
  ['--connx-accordion-header-icon-color-hover', 'var(--connx-grey)'],

  ['--connx-accordion-header-icon-background-active', 'var(--connx-accordion)'],
  ['--connx-accordion-header-icon-color-active', 'var(--connx-grey)'],

  ['--connx-accordion-border-radius', '0.5rem'],
  ['--connx-accordion-border', 'var(--connx-grey-tint-65)'],
  ['--connx-accordion-border-bottom', 'var(--connx-accordion-border)'],
  ['--connx-accordion-background', 'var(--connx-white)'],
];

const defaultNavigation = [
  ['--connx-navigation-background', 'var(--connx-white)'],
  ['--connx-navigation-background-hover', 'var(--connx-grey-tint-90)'],
  ['--connx-navigation-text', 'var(--connx-grey-shade-45)'],
  ['--connx-navigation-text-hover', 'var(--connx-grey-shade-30)'],
  ['--connx-navigation-logo-fill', 'var(--connx-grey-shade-30)'],
];

const gridThemeMap = new Map([
  ['default', defaultGrid],
  ['#000000', darkGrid],
  ['#cccccc', lightGrid],
  ['#ffffff', whiteGrid],
]);

const accordionThemeMap = new Map([
  ['default', defaultAccordion],
  ['#000000', darkAccordion],
  ['#cccccc', lightAccordion],
  ['#ffffff', whiteAccordion],
]);

const navigationThemeMap = new Map([['default', defaultNavigation]]);

export { gridThemeMap, accordionThemeMap, navigationThemeMap };
